(function () {
    'use strict';

    angular.module("imApp").factory("subscriptionGridService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 3207,
                    parameters: parms || {}
                });
            },
            listIsActive: function (parms) {
                return $ihttp.post({
                    method: 3252,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
